const o = "footer", t = "footer__copyright", r = {
  footer: o,
  "footer__first-row": "footer__first-row",
  "footer__columns-container": "footer__columns-container",
  "footer__second-row": "footer__second-row",
  "footer__third-row": "footer__third-row",
  "footer__quick-links": "footer__quick-links",
  "footer__column-title": "footer__column-title",
  "footer__stock-price": "footer__stock-price",
  "footer__quick-links-nav": "footer__quick-links-nav",
  "footer__social-links-nav": "footer__social-links-nav",
  footer__copyright: t,
  "footer__social-links": "footer__social-links",
  "footer__service-links": "footer__service-links",
  "footer__legal-text": "footer__legal-text",
  "footer--with-extra-columns": "footer--with-extra-columns"
};
export {
  r as default,
  o as footer,
  t as footer__copyright
};
